import { ChallengeStatus } from "@/pages/challenges/types";
import {
  ChallengeActiveCard,
  ChallengeCancelledCard,
  ChallengeCompletedCard,
  ChallengeLiveCard,
  ChallengeStartedCard,
} from "./components/cards/ChallengeInfoCards";

export type ChallengeInfoProps = {
  status: ChallengeStatus;
  gainedAmount?: string;
  targetAmount?: string;
  deadline?: string;
  youtubeLink?: string;
};

const ComponentMap: Partial<
  Record<ChallengeStatus, React.FC<ChallengeInfoProps>>
> = {
  [ChallengeStatus.ACTIVE]: ChallengeActiveCard,
  [ChallengeStatus.CANCELED]: ChallengeCancelledCard,
  [ChallengeStatus.COMPLETED]: ChallengeCompletedCard,
  [ChallengeStatus.DETERMINING_WINNERS]: ChallengeLiveCard,
  [ChallengeStatus.STARTED]: ChallengeStartedCard,
};

const ChallengeInfo = ({ status, ...props }: ChallengeInfoProps) => {
  const CardComponent = ComponentMap[status];

  if (!CardComponent) {
    return null;
  }

  return <CardComponent status={status} {...props} />;
};

export default ChallengeInfo;
